import React, { useEffect, useState } from "react";
import axios from "axios";

const Dashboard = ({ patient }) => {
  const [investigations, setInvestigations] = useState([]);

  useEffect(() => {
    axios.get(`https://ndcapps.in/webrptapi/invrpts/get_reports.php?patid=${patient.patid}`)
      .then(response => {
        if (response.data.success) {
          setInvestigations(response.data.investigations);
        }
      })
      .catch(error => console.error("Error fetching data", error));
  }, [patient.patid]);

  //const handleDownload = async (opdtransinvestigationid,filename, rptdir, invdeptid) => {
    const handleDownload = async (opdtransinvestigationid) => {
    try {
      const response = await axios.get(`https://ndcapps.in/webrptapi/invrpts/download.php?opdtransinvestigationid=${opdtransinvestigationid}`, {
        responseType: "blob", // Ensure response is treated as a file
      });

       let filename = "report.pdf";

    // Read filename from Content-Disposition header
    const disposition = response.headers["content-disposition"];

    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    const url = window.URL.createObjectURL(response.data);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download failed", error);
  }

  };

  return (
    <div className="container mt-4">
      {/* Patient Info Panel */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h4 className="card-title text-center">Welcome, {patient.patname}
         
          </h4>
          <a tyle="float:right; color:#000000" href="https://northcitydiagnostic.com">BACK</a>
        </div>
      </div>

       {/* Investigations Table */}
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="mb-3">Your Investigations</h5>
          <table className="table table-bordered table-hover">
            <thead className="table-primary">
              <tr>
                <th>Investigation Name</th>
              
                <th>Report</th>
              </tr>
            </thead>
            <tbody>
          {investigations.map((inv, index) => (
            <tr key={index}>
              <td>{inv.investigation}</td>
             
              <td className="text-center">
                {inv.rptfilename ? (
                 <button
                 className="btn btn-outline-primary btn-sm"
                 
                 onClick={() => handleDownload(inv.opdtransinvestigationid)}
               >
                 <span role="img" aria-label="emoji name">
                 📥 </span>Download
               </button>
                ) : (
                  "Not Available"
                )}
              </td>
            </tr>
          ))}
        </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;